import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { toast } from 'react-toastify';
import { apiClient } from '../../../Api/client';
import { useModalCrudState } from '../../../_helper/hooks/useModalCrudState';
import { useFirstErrorFocus } from '../../../_helper/hooks/useFirstErrorFocus';

const PasswordModal = ({ isOpen, toggle, employee, apiEndpoint }) => {
    const initialFormData = {
        password: '',
        confirmPassword: '',
    };

    const {
        formData,
        setFormData,
        errors,
        setErrors,
        handleCancel,
    } = useModalCrudState({
        isOpen,
        mode: 'add',
        selectedItem: null,
        initialData: initialFormData,
        toggle,
    });
    const focusFirstError = useFirstErrorFocus();

    const handlePasswordChange = (e) => {
        setFormData(prev => ({ ...prev, password: e.target.value }));
        if (errors.password || errors.confirmPassword || errors.form) {
            setErrors({});
        }
    };

    const handleConfirmPasswordChange = (e) => {
        setFormData(prev => ({ ...prev, confirmPassword: e.target.value }));
        if (errors.password || errors.confirmPassword || errors.form) {
            setErrors({});
        }
    };

    const validatePasswords = () => {
        const validationErrors = {};

        if (!formData.password) {
            validationErrors.password = 'Şifre alanı boş bırakılamaz.';
        }
        if (formData.password !== formData.confirmPassword) {
            validationErrors.confirmPassword = 'Girilen şifreler eşleşmiyor.';
        }

        if (formData.password && formData.password.length < 6) {
            validationErrors.password = 'Şifre en az 6 karakter olmalıdır.';
        }

        setErrors(validationErrors);
        return validationErrors;
    };

    // Şifre alanlarını doğrulayıp ilgili kullanıcı için şifre güncelleme isteği gönderir
    const handleConfirm = async () => {
        const validationErrors = validatePasswords();
        if (Object.keys(validationErrors).length > 0) {
            focusFirstError(validationErrors);
            return;
        }

        if (!employee || !employee.id) {
            toast.error('Çalışan bilgisi bulunamadı.');
            return;
        }

        try {
            await apiClient.post(`${apiEndpoint}/${employee.id}/set-password`, { newPassword: formData.password });

            toast.success(`${employee.firstName || 'Çalışan'}'ın şifresi başarıyla güncellendi!`);
            handleCancel();
        } catch (err) {
            const errorMsg = err.response?.data?.message || err.response?.data?.title || 'Şifre güncellenirken bir hata oluştu.';
            toast.error(errorMsg);
            setErrors({ form: errorMsg });
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel}>
            <ModalHeader toggle={handleCancel}>
                Şifre Belirle ({employee ? `${employee.firstName} ${employee.lastName}` : 'Çalışan'})
            </ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label for="password">Yeni Şifre <span className="text-danger">*</span></Label>
                    <Input
                        type="password"
                        id="password"
                        name="password"
                        value={formData.password}
                        onChange={handlePasswordChange}
                        invalid={!!errors.password}
                        placeholder="Yeni şifreyi girin"
                    />
                    {errors.password && <FormFeedback style={{ display: 'block', marginTop: '0.25rem' }}>{errors.password}</FormFeedback>}
                </FormGroup>
                <FormGroup>
                    <Label for="confirmPassword">Yeni Şifre (Tekrar) <span className="text-danger">*</span></Label>
                    <Input
                        type="password"
                        id="confirmPassword"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleConfirmPasswordChange}
                        invalid={!!errors.confirmPassword || !!errors.form}
                        placeholder="Yeni şifreyi tekrar girin"
                    />
                    {(errors.confirmPassword || errors.form) && <FormFeedback style={{ display: 'block', marginTop: '0.25rem' }}>{errors.confirmPassword || errors.form}</FormFeedback>}
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-pill btn-outline-success" onClick={handleConfirm}>
                    Şifreyi Belirle
                </button>
                <button className="btn btn-pill btn-outline-secondary" onClick={handleCancel}>
                    İptal
                </button>
            </ModalFooter>
        </Modal>
    );
};

export default PasswordModal;
